import axios from "axios";

export const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BASE}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("ph_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const assetUrl = (path) => (path ? `${BASE}${path}` : null);
export const downloadUrl = (id, fmt) => `${API}/documents/${id}/download?format=${fmt}`;
export const previewUrl = (id) => `${API}/documents/${id}/preview`;
export const versionDownloadUrl = (id, idx, fmt) => `${API}/documents/${id}/versions/${idx}/download?format=${fmt}`;
export const versionPreviewUrl = (id, idx) => `${API}/documents/${id}/versions/${idx}/preview`;

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail?.msg || String(detail);
}

export function formatSize(bytes = 0) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export const asArray = (v) => (Array.isArray(v) ? v : []);

export const CATEGORIES = [
  "Cables and Wires", "Switchgear", "Lighting", "Electrical Accessories", "Cable Accessories",
  "Earthing Materials", "Industrial Products", "Automation Products", "Electrical Panels and Components",
  "Switches", "Home Automation",
];
